import { 
    FaArrowLeft,
    FaArrowRight,
    } from 'react-icons/fa'; // Import the left arrow icon
    import { Link, useLocation } from "react-router-dom";
import { AboutUsCardListAR } from './aboutUsData.js';
import { AboutUsCardListEN } from './aboutUsData.js';
import { useLanguage } from '../context/LanguageContext.js';
import { Helmet } from 'react-helmet';
import { getRoute } from "../utils/getRoute.js";
export default function AboutUs(){
    const { t, language} = useLanguage();
    const AboutUsCardList=language=="en"?AboutUsCardListEN:AboutUsCardListAR;
    const AboutUsCradShow=AboutUsCardList.map((card)=>{
        return<div key={card.id} className='card'>
<h3 className='card-title'>{card.title}</h3>
<div className='card-img'><img src={card.img} alt='card-image'/></div>
<p className='card-description'>{card.description}</p>
        </div>
    });
    const location = useLocation();
    const canonicalUrl = window.location.origin + location.pathname;
    return <div className="container">
 <Helmet>
 <title>ام بي تك - Mptech | من نحن</title>
 <link rel="canonical" href={canonicalUrl} />
         <meta 
          name="description" 
          content="تظهر ملخص عن أقسام الفريق ونوع الموظفين ووصف بسيط لمميزاتهم، توجد نافذة تدخلك إلى الخدمات، هذه الصفحة جذابة ويوجد فيها إضاءات وتفاعل مع حركي مع العناوين" 
        />
        <meta 
          name="keywords" 
          content="خدمات تقنية 
وكالة تسويق رقمي 
تسويق إلكتروني
المحامي الذكي
تصميم شعار
مواقع إلكترونية
تصميم تطبيقات
مصور تغطيات إعلامية
صيانة برمجيات
حملات بريد الكتروني
مصور افنت
تصميم تطبيقات للكمبيوتر
نظام محاسبي
اي ار بي
ERP
موقع تعريفي
صناعة موقع كبير
تحسين محركات البحث
ام بي تك
شركة تسويق في جدة
شركة تقنية في جدة"
        />
 </Helmet>
        <div className="container aboutUs-container" style={{direction:language==="en"?"ltr":"rtl"}}>
            <div className="aboutUs-img-div">
            <img  src={require(language=="ar"?'../assests/home-img-AR.jpg':'../assests/home-img-EN.jpg')}
        
        alt="My-Image"/>
        <div className='aboutUs-description' style={{padding:language==="en"&&"0 0 0 40px"}}>
        <p className='section-title'>{t('aboutUs_page.section_title')}</p>
  <h2>{t('aboutUs_page.section_sub_title')}</h2>
  <p className='about-description-paragraph'>{t('aboutUs_page.section_description')}</p>
  <Link to={getRoute('service', language)}><button className='btn btn-with-icon' >{t('aboutUs_page.btn_service_more')} 
  {language==="ar"?<FaArrowLeft className='arrow-icon-left'/>:<FaArrowRight className='arrow-icon-left'/>}
    </button></Link> 
        </div>
            </div>

        </div>
       <div className='task-container'>
       <p className='section-title'>{t('our_task.section_title')}</p>
       <p className='about-description-paragraph'>{t('our_task.section_description')}</p>
       <div className='aboutUs-card-container'>
{AboutUsCradShow}
       </div>
       </div>
    </div>
}